import { render, staticRenderFns } from "./NewRegistration.vue?vue&type=template&id=5d6c0a03"
import script from "./NewRegistration.vue?vue&type=script&lang=js"
export * from "./NewRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports